import $ from 'jquery';
import { Loader } from '@googlemaps/js-api-loader';

const renderMap = (google, target, coordinate) => {
    const icon = {
        path: 'M32.6536,16.3271 C32.6536,20.7061 30.9196,24.6731 28.1136,27.6051 L28.1116,27.6211 L16.8216,40.5691 L5.0726,28.1511 L5.0866,28.1481 C5.0866,28.1481 -0.0004,20.9831 -0.0004,16.3271 C-0.0004,7.3091 7.3096,0.0001 16.3266,0.0001 C25.3436,0.0001 32.6536,7.3091 32.6536,16.3271 Z M12.3687,15.832 C12.3687,18.018 14.1407,19.79 16.3267,19.79 C18.5127,19.79 20.2847,18.018 20.2847,15.832 C20.2847,13.646 18.5127,11.874 16.3267,11.874 C14.1407,11.874 12.3687,13.646 12.3687,15.832 Z',
        fillColor: '#C8365E',
        fillOpacity: 1,
        strokeWeight: 1,
        strokeColor: '#A30046',
        scale: 1.0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(16, 40)
    };

    // const latLong = address.split(',');
    const map = new google.maps.Map(target, {
        panControl: true,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        fullscreenControl: false,
        rotateControl: false,
        center: coordinate,
        zoom: 14,
        styles: []
    });

    const marker = new google.maps.Marker({
        position: coordinate,
        icon,
        map
    });

    // resize icon for small tiles
    if ($(target).closest('.tile-small').length > 0) {
        const scaledIcon = marker.getIcon();
        scaledIcon.scale = 0.75;
        marker.setOptions({ icon: scaledIcon });
    }

    $(window).resize(() => {
        map.panTo(marker.getPosition());
    });
};

const getLatLong = (google, $mapCanvas, address) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK') {
            renderMap(google, $mapCanvas, results[0].geometry.location);
        } else {
            // eslint-disable-next-line no-alert
            alert(`Geocode was not successful for the following reason: ${status}`);
        }
    });
};

const initMap = () => {
    const $mapCanvas = $('.map_canvas');

    if ($mapCanvas.length === 0) return;

    const loader = new Loader({
        apiKey: 'AIzaSyAGOv4Ns0-F6bNjrxXpOmd8dJx2cNsevcw',
        version: 'weekly'
    });

    loader.load().then(google => {
        for (let i = 0; i < $mapCanvas.length; i += 1) {
            getLatLong(google, $mapCanvas[i], $($mapCanvas[i]).data('address'));
        }
    });
};

$(() => {
    initMap();
});
